// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TableTokens } from './type';

const tableTokens: TableTokens = {
  tableFontSize: 'Font-14',
  tableCellPaddingX: 'Spacing-12',
  tableCellPaddingY: 'Spacing-8',
  tableCellBorderColor: 'Neutral-border-1',
  tableCellFontSize: 'Font-14',
  tableCellFontWeight: 'Weight-regular',
  tableSmallTheadFontSize: 'Font-14',
  tableSmallTheadFontWeight: 'Weight-medium',
  tableSmallCellPaddingX: 'Spacing-8',
  tableSmallCellPaddingY: 'Spacing-4',
  tableSmallCellFontSize: 'Font-14',
  tableSmallCellFontWeight: 'Weight-regular',
  tableLargeTheadFontSize: 'Font-14',
  tableLargeTheadFontWeight: 'Weight-medium',
  tableLargeCellPaddingX: 'Spacing-16',
  tableLargeCellPaddingY: 'Spacing-16',
  tableLargeCellFontSize: 'Font-14',
  tableLargeCellFontWeight: 'Weight-regular',
  tableFixedShadow: 'rgba(2,11,24,.1)',
  tableTheadBackgroundColor: 'Neutral-fill-2',
  tableTheadFontSize: 'Font-14',
  tableTheadFontWeight: 'Weight-medium',
  tableTheadFontColor: 'Neutral-text-5',
  tableTbodyBackgroundColor: 'Neutral-fill-1',
  tableTbodyStripedBackgroundColor: 'Neutral-fill-2',
  tableTbodyHoverBackgroundColor: 'Indigo-1',
  tableTbodyActiveBackgroundColor: 'Brand-1',
  tableTbodyFontColor: 'Neutral-text-5',
  tableTfootBackgroundColor: 'Neutral-fill-2',
  tableTfootFontColor: 'Neutral-text-5',
  tableTfootFontWeight: 'Weight-regular',
  tableExpandIconSize: 'Size-7',
  tableExpandIconColor: 'Neutral-text-2',
  tableExpandIconHoverBackgroundColor: 'Neutral-fill-3',
  tableExpandBackgroundColor: 'Neutral-fill-2',
  tableSorterColor: 'Neutral-text-3',
  tableSorterHoverColor: 'Neutral-text-4',
  tableSorterActiveColor: 'Brand-6',
  tableFilterHeaderPaddingX: 'Spacing-12',
  tableFilterHeaderPaddingY: 'Spacing-12',
  tableFilterBodyPaddingX: 'Spacing-12',
  tableFilterBodyPaddingY: 'Spacing-8',
  tableFilterFooterPaddingX: 'Spacing-12',
  tableFilterFooterPaddingY: 'Spacing-8',
  tableFilterFooterBorderColor: 'Neutral-border-1',
  tableFilterInputMarginBottom: 'Spacing-8',
  tableFilterInputIconSize: 'Font-14',
  tableFilterInputIconColor: 'Neutral-text-4',
  tableFilterInputIconMarginRight: 'Spacing-8',
  tableFilterIconColor: 'Neutral-text-3',
  tableFilterIconHoverColor: 'Neutral-text-4',
  tableFilterIconHoverBackgroundColor: 'Neutral-fill-3',
  tableFilterIconActiveColor: 'Brand-6',
  tableFilterIconPadding: 'Spacing-4',
  tableFilterIconSize: 'Font-14',
  tableResizeColor: 'Brand-7',
  tableSelectionBorderColor: 'Brand-6',
  tablePaginationMarginY: 'Spacing-12',
};

export default tableTokens;
